import { render } from "./VipList.vue?vue&type=template&id=2c5fb2d2&scoped=true"
import script from "./VipList.vue?vue&type=script&lang=js"
export * from "./VipList.vue?vue&type=script&lang=js"

import "./VipList.vue?vue&type=style&index=0&id=2c5fb2d2&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5fb2d2"]])

export default __exports__